import { styled } from "@mui/material/styles";
import MuiDialogTitle from "@mui/material/DialogTitle";

export const DialogTitle = styled(MuiDialogTitle, {
    shouldForwardProp: (prop) => prop !== "theme",
})(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    lineHeight: "1em",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: "1.5rem",
    mb: 2,
}));
